export enum LobbyVisibilityEnum {
    Public = 0,
    Friends = 1
}